/* hc-bundle-builder.js — Build Your Bundle
   Talks to the AJAX Cart API. The tier math here is a PREVIEW; the real
   discount is applied by the Heavy Bundle discount function at checkout.
   Only products in the bundle collection count toward the tiers, matching
   the function's bundle-eligible tag logic. */
(function () {
  var root = document.querySelector('.hcbb');
  if (!root) return;

  var cfgEl = root.querySelector('[data-hcbb-config]');
  var CFG = JSON.parse(cfgEl.textContent);
  var TIERS = CFG.tiers
    .filter(function (t) { return t.t >= 0 && t.p > 0; })
    .sort(function (a, b) { return a.t - b.t; });   // t === 0 -> quantity-based tier
  var MIN_ITEMS = CFG.minItems || 2;
  var PRODUCTS = CFG.products.filter(function (p) { return p.available; });
  var ELIGIBLE = {};
  PRODUCTS.forEach(function (p) { ELIGIBLE[p.handle] = p; });
  var PREFERRED = (CFG.preferred || []).map(trim).filter(Boolean);
  var DEPRIORITIZED = (CFG.deprioritized || []).map(trim).filter(Boolean);
  var STR = CFG.strings || {};

  function trim(s) { return String(s).trim(); }
  // Shopify Markets: cart totals arrive in presentment currency, but tier
  // thresholds are configured in the STORE currency. Shopify publishes the
  // live conversion rate on every storefront page.
  function fxRate() {
    try {
      var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
      return (r && r > 0) ? r : 1;
    } catch (e) { return 1; }
  }
  function thr(t) { return Math.round(t.t * 100 * fxRate()); } // threshold in presentment cents
  function money(cents) {
    if (CFG.currencyCode) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: CFG.currencyCode }).format(cents / 100);
      } catch (e) { /* fall through */ }
    }
    return (CFG.currency || '$') + (cents / 100).toFixed(2);
  }
  function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function fmt(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (_, k) {
      return (k in map) ? map[k] : '{' + k + '}';
    });
  }

  var cartState = { rows: [], count: 0, subtotal: 0, grams: 0 };

  // ---------- cart API ----------
  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var rows = cart.items.filter(function (it) { return ELIGIBLE[it.handle]; });
        function lineOriginal(r) { // pre-discount line price: Shopify evaluates tier minimums on this
          return (r.original_line_price != null) ? r.original_line_price : r.final_line_price;
        }
        cartState = {
          rows: rows,
          count: rows.reduce(function (s, r) { return s + r.quantity; }, 0),
          subtotal: rows.reduce(function (s, r) { return s + lineOriginal(r); }, 0),
          grams: rows.reduce(function (s, r) { return s + (r.grams || 0) * r.quantity; }, 0)
        };
        render();
      })
      .catch(function () { /* leave last known state */ });
  }
  function addVariant(variantId, btn) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      if (btn) {
        var orig = btn.textContent;
        btn.textContent = 'Added';
        btn.classList.add('added');
        setTimeout(function () { btn.textContent = orig; btn.classList.remove('added'); }, 650);
      }
      return refreshCart();
    }).catch(function () { if (btn) btn.textContent = 'Try again'; });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(refreshCart).catch(refreshCart);
  }

  // ---------- tier math (all cents) ----------
  function tierFor(subtotal, count) {
    if (count < MIN_ITEMS) return null;
    var hit = null;
    TIERS.forEach(function (t) { if (subtotal >= thr(t)) hit = t; });
    return hit;
  }
  function nextTier(subtotal) {
    for (var i = 0; i < TIERS.length; i++) if (subtotal < thr(TIERS[i])) return TIERS[i];
    return null;
  }

  // ---------- gap-closer recommendation ----------
  function recommend(st) {
    var next = nextTier(st.subtotal);
    var first = st.count > 0 && st.count < MIN_ITEMS; // 1 item: any eligible product makes a bundle
    if (st.count === 0 || (!next && !first)) return null;
    var gap = first ? 0 : thr(next) - st.subtotal;
    var inCart = {};
    st.rows.forEach(function (r) { inCart[r.handle] = true; });
    var cands = PRODUCTS.filter(function (p) { return p.price >= gap && !inCart[p.handle]; }); // never what's already in the cart
    if (first) cands = cands.filter(function (p) { return DEPRIORITIZED.indexOf(p.handle) === -1; }); // starter pick is never a banner
    if (!cands.length) return null;
    var nonDep = cands.filter(function (p) { return DEPRIORITIZED.indexOf(p.handle) === -1; });
    if (nonDep.length) cands = nonDep;
    cands.sort(function (a, b) {
      var ap = PREFERRED.indexOf(a.handle), bp = PREFERRED.indexOf(b.handle);
      var aP = ap > -1, bP = bp > -1;
      if (aP !== bP) return aP ? -1 : 1;
      if (aP && bP) return ap - bp;
      var aN = !inCart[a.handle], bN = !inCart[b.handle];
      if (aN !== bN) return aN ? -1 : 1;
      return a.price - b.price;
    });
    var pick = cands[0];
    var cur = tierFor(st.subtotal, st.count);
    var newSub = st.subtotal + pick.price;
    var newTier = null;
    TIERS.forEach(function (t) { if (newSub >= thr(t)) newTier = t; });
    if (!newTier || (cur && newTier.p <= cur.p)) return null; // must genuinely reach a higher tier
    var extraSave = newSub * newTier.p / 100 - st.subtotal * (cur ? cur.p : 0) / 100;
    return { pick: pick, next: newTier, gap: gap, extraSave: Math.max(0, extraSave), first: first };
  }

  // ---------- renderers ----------
  function legendHTML(active) {
    var h = '<div class="hcbb-legend__grid">';
    TIERS.forEach(function (t) {
      var req = t.t === 0
        ? 'Any ' + MIN_ITEMS + ' items'
        : 'Spend ' + money(thr(t)) + '+';
      h += '<div class="hcbb-legend__cell ' + (active && active.t === t.t ? 'hit' : '') + '">' +
        '<b>' + t.p + '% off</b><span>' + req + '</span></div>';
    });
    return h + '</div>';
  }
  function tierDone(st, t) {
    if (st.count < MIN_ITEMS) return false;
    return t.t === 0 || st.subtotal >= thr(t);
  }
  function progressHTML(st) {
    var top = TIERS[TIERS.length - 1];
    var maxT = thr(top); // 20% is the finish line
    var h = '<div class="hcbb-fill" style="width:' + Math.min(100, st.subtotal / maxT * 100) + '%"></div>';
    TIERS.forEach(function (t) {
      if (t.t === 0 || t === top) return; // quantity tier: no marker; top tier: finish label
      var done = tierDone(st, t);
      h += '<div class="hcbb-mark" style="left:' + (thr(t) / maxT * 100) + '%">' +
        '<span class="' + (done ? 'done' : '') + '" style="white-space:nowrap">' + (done ? '\u2713 ' : '') + t.p + '%</span></div>';
    });
    var topDone = tierDone(st, top);
    h += '<div class="hcbb-finish ' + (topDone ? 'done' : '') + '">' + (topDone ? '\u2713 ' : '') + top.p + '%</div>';
    return h;
  }
  function chipsHTML(st) {
    var next = nextTier(st.subtotal);
    return TIERS.map(function (t) {
      var cls = 'hcbb-chip';
      if (tierDone(st, t)) cls += ' done';
      else if (st.count >= MIN_ITEMS && next && next.t === t.t) cls += ' next';
      else cls += ' locked';
      var label = (tierDone(st, t) ? '\u2713 ' : '') + t.p + '%';
      return '<span class="' + cls + '">' + label + '</span>';
    }).join('');
  }
  function nudgeText(st) {
    var tr = tierFor(st.subtotal, st.count), next = nextTier(st.subtotal);
    if (st.count === 0) return STR.empty || 'Empty.';
    if (st.count < MIN_ITEMS) return fmt(STR.one_more_item, { n: MIN_ITEMS - st.count });
    if (next) {
      var cur = tr ? ' — currently saving ' + tr.p + '%' : '';
      return fmt(STR.from_off, { gap: money(thr(next) - st.subtotal), pct: next.p, cur: cur });
    }
    return fmt(STR.top, { pct: tr.p });
  }
  function nudgeHTML(st) {
    var next = nextTier(st.subtotal);
    var txt = nudgeText(st);
    if (st.count >= MIN_ITEMS && next) {
      var gapStr = money(thr(next) - st.subtotal);
      txt = txt.replace(gapStr, '<b class="hcbb-gap-amt">' + gapStr + '</b>');
    }
    return txt;
  }
  function thumb(url) {
    if (!url) return '';
    var sized = url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
    return '<img class="hcbb-brow__img" src="' + sized + '" alt="" loading="lazy">';
  }
  function listHTML(st) {
    if (!st.rows.length) return '<div class="hcbb-bempty">Nothing yet.</div>';
    return st.rows.map(function (r) {
      var variant = (r.variant_title && r.variant_title !== 'Default Title')
        ? '<span class="cl">' + r.variant_title + '</span>' : '';
      return '<div class="hcbb-brow">' +
        thumb(r.image) +
        '<div class="hcbb-brow__info"><span class="nm">' + r.product_title + '</span>' + variant + '</div>' +
        '<div style="display:flex;align-items:center;gap:12px">' +
        '<span>' + money(r.original_line_price != null ? r.original_line_price : r.final_line_price) + '</span>' +
        '<span class="hcbb-qty">' +
        '<button type="button" data-hcbb-dec="' + r.key + '">−</button>' +
        '<span>' + r.quantity + '</span>' +
        '<button type="button" data-hcbb-inc="' + r.key + '" data-q="' + r.quantity + '">+</button>' +
        '</span></div></div>';
    }).join('');
  }
  function totHTML(st) {
    var tr = tierFor(st.subtotal, st.count);
    var disc = tr ? tr.p : 0;
    var amt = Math.round(st.subtotal * disc / 100);
    var pay = st.subtotal - amt;
    return '<div><b>Subtotal</b><span>' + money(st.subtotal) + '</span></div>' +
      '<div><b>Bundle discount</b><span>' + (disc > 0
        ? '<span class="hcbb-savetag">−' + disc + '%</span> −' + money(amt)
        : '—') + '</span></div>' +
      '<div class="pay"><b style="font-size:.85rem">You pay</b><span>' +
      (disc > 0 ? '<s>' + money(st.subtotal) + '</s>' : '') + money(pay) + '</span></div>' +
      (disc > 0 ? '<div style="font-size:.68rem;opacity:.55;justify-content:flex-end">' + (STR.checkout_note || '') + '</div>' : '');
  }
  function recHTML(r) {
    if (!r) return '';
    return '<div class="hcbb-rec">' +
      '<span class="hcbb-rec__tag">' + (STR.rec_tag || 'One more thing') + '</span>' +
      '<div class="hcbb-rec__row">' +
      (r.pick.image ? '<img class="hcbb-rec__img" src="' + r.pick.image + '" alt="" loading="lazy">' : '') +
      '<div class="hcbb-rec__nm">' +
      r.pick.title + ' · ' + money(r.pick.price) +
      '<small>' + (r.first ? 'Makes it a bundle. ' + r.next.p + '% off.' : fmt(STR.rec_line, { pct: r.next.p, save: money(r.extraSave) })) + '</small></div>' +
      '<button type="button" class="hcbb-rec__btn" data-hcbb-recadd="' + r.pick.variantId + '">Add</button>' +
      '</div></div>';
  }
  function alertHTML(st, r) {
    var next = nextTier(st.subtotal);
    if (st.count === 0 || !next || !r) return '';
    var gap = thr(next) - st.subtotal;
    return '<button type="button" class="hcbb-alert" data-hcbb-recadd="' + r.pick.variantId + '">' +
      '<small>' + (STR.almost || 'Almost there') + '</small>' +
      money(gap) + ' from ' + next.p + '% off — <u>' +
      fmt(STR.add_a, { product: r.pick.title }) + '</u></button>';
  }

  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('hcbb render:', e); } }
  function render() {
    var st = cartState;
    var active = tierFor(st.subtotal, st.count);
    var rec = null;
    if (!root.hasAttribute('data-hcbb-norec')) safe(function () { rec = recommend(st); });
    var lbs = st.grams > 0 ? (st.grams / 453.592) : 0;

    safe(function () { root.querySelector('[data-hcbb-legend]').innerHTML = legendHTML(active); });
    qa('[data-hcbb-weight]').forEach(function (el) {
      el.textContent = (lbs >= 0.05 ? lbs.toFixed(lbs >= 10 ? 0 : 1) : '0') + ' LB of product';
    });
    safe(function () { qa('[data-hcbb-progress]').forEach(function (el) { el.innerHTML = progressHTML(st); }); });
    safe(function () { qa('[data-hcbb-chips]').forEach(function (el) { el.innerHTML = chipsHTML(st); }); });
    safe(function () { qa('[data-hcbb-nudge]').forEach(function (el) { el.innerHTML = nudgeHTML(st); }); });
    safe(function () { qa('[data-hcbb-list]').forEach(function (el) { el.innerHTML = listHTML(st); }); });
    safe(function () { qa('[data-hcbb-rec]').forEach(function (el) { el.innerHTML = recHTML(rec); }); });
    safe(function () { qa('[data-hcbb-tot]').forEach(function (el) { el.innerHTML = totHTML(st); }); });
    qa('[data-hcbb-cta]').forEach(function (el) {
      el.setAttribute('aria-disabled', st.count < MIN_ITEMS ? 'true' : 'false');
    });

    // toast above the bottom tracker
    var tw = root.querySelector('[data-hcbb-toastwrap]');
    tw.innerHTML = alertHTML(st, rec);
    var bar = root.querySelector('[data-hcbb-mbar]');
    var barVisible = window.getComputedStyle(bar).display !== 'none';
    tw.style.bottom = barVisible ? bar.offsetHeight + 'px' : '0px';

    // mobile bar
    var disc = active ? active.p : 0;
    var pay = st.subtotal - Math.round(st.subtotal * disc / 100);
    root.querySelector('[data-hcbb-mtotal]').textContent = money(pay);
    root.querySelector('[data-hcbb-mnudge]').textContent =
      st.count === 0 ? 'Add ' + MIN_ITEMS + ' items to start saving' : nudgeText(st);
    root.querySelector('[data-hcbb-mcount]').textContent = st.count;
    var maxT = thr(TIERS[TIERS.length - 1]);
    root.querySelector('[data-hcbb-mfill]').style.width = Math.min(100, st.subtotal / maxT * 100) + '%';
  }

  // ---------- events (delegated) ----------
  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-hcbb-swatch],[data-hcbb-add],[data-hcbb-recadd],[data-hcbb-dec],[data-hcbb-inc],[data-hcbb-open],[data-hcbb-close]') : null;
    if (!t) return;
    if (t.hasAttribute('data-hcbb-swatch')) {
      if (t.disabled) return;
      var scard = t.closest('[data-hcbb-card]');
      scard.querySelectorAll('[data-hcbb-swatch]').forEach(function (s) { s.classList.remove('on'); });
      t.classList.add('on');
      var hidden = scard.querySelector('input[data-hcbb-variant]');
      if (hidden) hidden.value = t.getAttribute('data-variant-id');
      var priceEl = scard.querySelector('[data-hcbb-price]');
      if (priceEl && t.getAttribute('data-price')) priceEl.textContent = t.getAttribute('data-price');
      var nameEl = scard.querySelector('[data-hcbb-swname]');
      if (nameEl) nameEl.textContent = t.getAttribute('data-title') || '';
      var img = scard.querySelector('.hcbb-pcard__img img');
      var src = t.getAttribute('data-image');
      if (img && src) { img.src = src; img.removeAttribute('srcset'); }
    } else if (t.hasAttribute('data-hcbb-add')) {
      var card = t.closest('[data-hcbb-card]');
      var vEl = card.querySelector('[data-hcbb-variant]');
      addVariant(vEl.value, t);
    } else if (t.hasAttribute('data-hcbb-recadd')) {
      addVariant(t.getAttribute('data-hcbb-recadd'), null);
    } else if (t.hasAttribute('data-hcbb-dec')) {
      var key = t.getAttribute('data-hcbb-dec');
      var row = cartState.rows.filter(function (r) { return r.key === key; })[0];
      changeLine(key, row ? row.quantity - 1 : 0);
    } else if (t.hasAttribute('data-hcbb-inc')) {
      changeLine(t.getAttribute('data-hcbb-inc'), Number(t.getAttribute('data-q')) + 1);
    } else if (t.hasAttribute('data-hcbb-open')) {
      root.querySelector('[data-hcbb-drawer]').classList.add('open');
      root.querySelector('[data-hcbb-toastwrap]').style.display = 'none';
    } else if (t.hasAttribute('data-hcbb-close')) {
      root.querySelector('[data-hcbb-drawer]').classList.remove('open');
      root.querySelector('[data-hcbb-toastwrap]').style.display = 'flex';
    }
  });

  window.addEventListener('resize', render);
  refreshCart();
})();
